const isPathWithin = (pathname, path) => (
  pathname === path || pathname.indexOf(`${path}/`) === 0
);

const isNavigationPathActive = (pathname = '', path = '', activePaths = [], exact = false) => {
  if (!path) {
    return false;
  }

  return [path, ...activePaths].some(activePath => (
    exact ? pathname === activePath : isPathWithin(pathname, activePath)
  ));
};

export { isNavigationPathActive };
